import i18next from 'i18next';
import React, {Component, PropTypes} from 'react';
import {findDOMNode} from 'react-dom';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classNames from 'classnames';
import {isMobile, toPX} from 'utils';

export default class Tooltip extends Component {
    static propTypes = {
        entities: ImmutablePropTypes.list.isRequired,
        rootWidth: PropTypes.number.isRequired,
        visible: PropTypes.bool.isRequired,
        expanded: PropTypes.bool.isRequired,
        openDown: PropTypes.bool.isRequired,
        onEntityClick: PropTypes.func.isRequired,
        onMoreClick: PropTypes.func.isRequired,
    };

    state = {
        style: {},
        arrowStyle: {},
    };

    componentDidMount() {
        this.calculateSizeAndPosition();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.entities !== this.props.entities || nextProps.rootWidth !== this.props.rootWidth) {
            const style = {...this.state.style};
            delete style.height;
            this.setState({style});
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.entities !== this.props.entities
            || nextProps.rootWidth !== this.props.rootWidth
            || nextProps.visible !== this.props.visible
            || nextProps.expanded !== this.props.expanded
            || nextProps.openDown !== this.props.openDown
            || nextState.style && !Immutable.fromJS(nextState.style).equals(Immutable.fromJS(this.state.style));
    }

    componentDidUpdate() {
        this.calculateSizeAndPosition();
    }

    getMaxEntities() {
        return isMobile() ? 3 : 5;
    }

    calculateSizeAndPosition() {
        const node = findDOMNode(this);
        if (!node) return;

        const style = {...this.state.style};
        const maxWidth = Math.floor(this.props.rootWidth * 0.9);
        let nodeWidth = node.offsetWidth;

        if (nodeWidth > maxWidth) {
            nodeWidth = maxWidth;
            style.whiteSpace = 'pre-wrap';
            style.width = toPX(maxWidth);
        } else if (!style.height) {
            delete style.whiteSpace;
            delete style.width;
            style.height = toPX(node.offsetHeight);
        }

        const parent = node.parentNode.parentNode;

        let positionX = parent.offsetWidth / 2 - nodeWidth / 2;
        let arrowPosition = nodeWidth / 2;

        const nodeLeft = parent.offsetLeft + positionX;
        const nodeRight = nodeLeft + nodeWidth;

        if (nodeLeft < 0) {
            positionX -= nodeLeft;
            arrowPosition = parent.offsetLeft + parent.offsetWidth / 2;
        } else if (nodeRight > this.props.rootWidth) {
            positionX += this.props.rootWidth - nodeRight;
            arrowPosition = nodeWidth - (this.props.rootWidth - parent.offsetLeft) + parent.offsetWidth / 2;
        }

        positionX += parent.offsetLeft;

        // 6px because the arrow width is 12px defined in CSS
        const arrowStyle = {left: toPX(Math.round(arrowPosition - 6))};

        let positionY = parent.offsetTop;
        if (this.props.openDown) {
            positionY += parent.offsetHeight;
        } else {
            positionY -= node.offsetHeight;
        }

        style.left = toPX(Math.round(positionX));
        style.top = toPX(Math.round(positionY));
        style.transformOrigin = `${arrowPosition / nodeWidth * 100}% ${this.props.openDown ? 0 : 100}%`;

        this.setState({style, arrowStyle});
    }

    handleEntityClick(entity) {
        return () => this.props.onEntityClick(entity);
    }

    render() {
        const {entities, expanded, openDown, onMoreClick} = this.props;

        const children = [];
        let index = -1;
        while (++index < entities.size) {
            const entity = entities.get(index);
            const count = entity.get('count');
            const displayAs = entity.get('displayAs');
            const types = entity.get('types').map(type => i18next.t(type)).join(' / ');

            children.push(
                <button
                    type='button'
                    className='cielo24-vwrap-entity'
                    key={index}
                    onClick={this.handleEntityClick(entity)}
                >
                    <span className='cielo24-vwrap-display'>{displayAs}</span>
                    <span className='cielo24-vwrap-types'>{types}</span>
                    <span className='cielo24-vwrap-pill'>{count}</span>
                </button>,
            );

            if (!expanded && index === this.getMaxEntities() - 1 && index < entities.size - 1) {
                const moreCount = entities.slice(index + 1).reduce((r, obj) => r + obj.get('count'), 0);
                children.push(
                    <div className='cielo24-vwrap-more' key='more'>
                        <button type='button' onClick={onMoreClick}>
                            {i18next.t('Show {{count}} more', {count: moreCount})}
                        </button>
                    </div>,
                );
                break;
            }
        }

        const className = classNames(
            'cielo24-vwrap-tooltip',
            {
                'cielo24-vwrap-down': openDown,
                'cielo24-vwrap-up': !openDown,
                'cielo24-vwrap-expanded': expanded,
            },
        );

        return (
            <div className={className} style={this.state.style}>
                <div className='cielo24-vwrap-content'>{children}</div>
                <div className='cielo24-vwrap-arrow' style={this.state.arrowStyle} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/heatmap/tooltip.js